export default __webpack_public_path__ + "static/cafe_36002-7a40afc0df6b4124b6d1cda95605a094.png";